import { ShieldCheckIcon } from 'lucide-react';

import { fundPage } from '@/content/engagement';
import { TDC_CHARITY_STATEMENT } from '@/lib/external-links';

export function FundTrust() {
  return (
    <section
      aria-labelledby="fund-trust-heading"
      className="px-4 py-12 sm:px-6 sm:py-16 lg:px-8"
    >
      <div className="border-border/70 bg-card/50 mx-auto w-full max-w-7xl rounded-2xl border px-6 py-10 shadow-sm backdrop-blur-sm sm:px-10">
        <div className="flex flex-wrap items-center gap-3">
          <span className="border-primary/35 bg-primary/10 text-primary inline-flex size-10 items-center justify-center rounded-xl border">
            <ShieldCheckIcon className="size-5" aria-hidden />
          </span>
          <h2
            id="fund-trust-heading"
            className="font-display text-foreground text-2xl font-semibold tracking-tight sm:text-3xl"
          >
            {fundPage.trustHeading}
          </h2>
        </div>
        <p className="text-muted-foreground mt-4 max-w-3xl text-base leading-relaxed sm:text-lg">
          {fundPage.trustBody}
        </p>
        <ul className="mt-6 grid gap-3 sm:grid-cols-2">
          {fundPage.trustSignals.map((signal) => (
            <li
              key={signal}
              className="border-border/60 bg-background/40 text-foreground/90 rounded-xl border px-4 py-3 text-sm leading-relaxed"
            >
              {signal}
            </li>
          ))}
        </ul>
        <p className="text-muted-foreground mt-6 text-xs leading-relaxed">{TDC_CHARITY_STATEMENT}</p>
      </div>
    </section>
  );
}
